export default function uploadImagesFile(file, callback){
    var formData = {
        files:file,
      };
      this.popup("fileUpload", { percent: 0, loading: true, onClose: () => {
        
      } });
      const id = this.dataGet("conf/popup2/show") ? "2" : "";
      this.filesXhr({
        action: "uploadImageFile",
        data: formData,
        success: data => {
            if(data.state == true){
              this.dataSet("conf/popup"+id+"/data/loading", false);
              callback(data);
            }
            if (data.state === false) {
                this.dataSet("conf/popup/data/loading", false);
                this.dataSet("conf/popup/show", false);
                this.error(this.translate(data.err), "Upload");
            }
        },
        progress: data => {
          this.dataSet("conf/popup"+id+"/data/percent",data.percent);
        }
      });
}